<template>
  <v-combobox
    v-model="filters"
    outlined
    dense
    multiple
    readonly
    item-color="primary"
    color="primary"
    hide-details
    :loading="loading"
    :items="filters"
    label="Поиск"
    prepend-inner-icon="mdi-magnify"
    @click="onClickCombobox"
  >
    <template #selection="{ item }">
      <v-chip
        small
        color="#dff0fd"
        text-color="primary"
        class="mt-1"
        @click="onClickCombobox"
      >
        <span class="pr-3"> {{ filterValues[item] }} </span>
        <v-icon
          v-if="!permanentList[item]"
          small
          @click.stop="onClickRemoveFilter(item)"
        >
          mdi-close-circle
        </v-icon>
      </v-chip>
    </template>
    <template #append>
      <div class="filter-dialog-append">
        <slot name="filter-list" />
        <slot name="save-filter" />
        <v-tooltip bottom>
          <template #activator="{ on }">
            <v-icon
              @click.stop="onClickRefresh"
              v-on="on"
              v-text="'mdi-refresh'"
            />
          </template>
          <span>Обновить</span>
        </v-tooltip>
      </div>
    </template>
  </v-combobox>
</template>

<script>
export default {
  props: {
    filters: {
      type: Array,
      default: () => []
    },
    filterValues: {
      type: Object,
      default: () => ({})
    },
    placeholder: {
      type: String,
      default: null
    },
    loading: {
      type: Boolean,
      default: false
    },
    permanentList: {
      type: Object,
      default: () => ({})
    }
  },
  methods: {
    onClickCombobox() {
      this.$emit("click");
    },
    onClickRemoveFilter(filterKey) {
      this.$emit("remove-filter", filterKey);
    },
    onClickRefresh() {
      this.$emit("refresh");
    },
    showUserFilters() {},
    saveFavoriteUserFilter() {
      this.$emit("save-favorite", this.selectedUserFilterId);
    }
  }
};
</script>

<style lang="scss">
.filter-dialog-append {
  span {
    vertical-align: middle;
  }
  button {
    margin-left: 5px;
  }
}
</style>
